var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isAvailable
    ? _c(
        "div",
        [
          _c(
            "b-btn",
            {
              staticClass: "fs-14 my-1",
              attrs: { variant: "custom-danger", size: "sm" },
              on: { click: _vm.showModal },
            },
            [_vm._v("Отклонить")]
          ),
          _c(
            "b-modal",
            {
              ref: "cancel-modal",
              attrs: {
                title: _vm.title,
                "no-close-on-backdrop": "",
                "no-close-on-esc": "",
                "hide-header-close": "",
                centered: "",
                size: "lg",
              },
              model: {
                value: _vm.isModalVisible,
                callback: function ($$v) {
                  _vm.isModalVisible = $$v
                },
                expression: "isModalVisible",
              },
            },
            [
              _c("form-row-single-select", {
                attrs: {
                  label: "Причина отклонения",
                  placeholder: "Выберите причину отклонения",
                  options: _vm.declineStatuses,
                  v: _vm.$v.form.decline_status_id,
                },
                model: {
                  value: _vm.form.decline_status_id,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "decline_status_id", $$v)
                  },
                  expression: "form.decline_status_id",
                },
              }),
              _c("form-row-edit-textarea", {
                attrs: {
                  label: "Комментарий",
                  v: _vm.$v.form.comment,
                  rows: 5,
                },
                model: {
                  value: _vm.form.comment,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "comment", $$v)
                  },
                  expression: "form.comment",
                },
              }),
              _c("form-row-single-line-document-upload", {
                attrs: {
                  title: "Обоснование причины отклонения",
                  v: _vm.$v.form.attachment,
                  "label-cols-sm": 4,
                  "label-cols-lg": 4,
                },
                model: {
                  value: _vm.form.attachment,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "attachment", $$v)
                  },
                  expression: "form.attachment",
                },
              }),
              _c("div", { staticClass: "text-danger fw-600 text-center" }, [
                _vm._v("ВНИМАНИЕ! Данная операция необратима."),
              ]),
              _c(
                "div",
                {
                  staticClass: "w-100 text-right",
                  attrs: { slot: "modal-footer" },
                  slot: "modal-footer",
                },
                [
                  _c(
                    "b-overlay",
                    {
                      staticClass: "d-inline-block",
                      attrs: {
                        show: _vm.isDataSending,
                        rounded: "",
                        opacity: "0.6",
                        "spinner-small": "",
                        "spinner-variant": "primary",
                      },
                    },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "text-uppercase mr-2",
                          attrs: { variant: "custom-outline-secondary" },
                          on: { click: _vm.cancelModal },
                        },
                        [_vm._v("Отмена")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-overlay",
                    {
                      staticClass: "d-inline-block",
                      attrs: {
                        show: _vm.isDataSending,
                        rounded: "",
                        opacity: "0.6",
                        "spinner-small": "",
                        "spinner-variant": "primary",
                      },
                    },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "text-uppercase",
                          attrs: {
                            variant: "custom-danger",
                            disabled: _vm.$v.$invalid,
                          },
                          on: { click: _vm.rejectProposal },
                        },
                        [_vm._v("Отклонить")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }